/* Create a dictionary object that stores the words and their definitions */
const dictionary = {
    "PENDING_PAYMENT": 'Pendiente por pago',
    "IN_PROCESS_PAYMENT": 'En Proceso',

    "PAYMENT_COMPLETED": 'Pago completado',
    "EXPIRED_PAYMENT": 'Expirado',
    "AUTHORIZED_PAYMENT": 'Autorizado',
    "REVERSE_PAYMENT": 'Reversa',
    "CANCELED_PAYMENT":"Cancelado",
    "INSUFFICIENT_BALANCE": 'Saldo insuficiente',
    "INTERNAL_ERROR": 'En este momento no podemos procesar tu solicitud, intenta más tarde.',
    "BAD_REQUEST": 'En este momento no podemos procesar tu solicitud, intenta más tarde.',
    "PROCESSOR_DECLINED": 'En este momento no podemos procesar tu solicitud, intenta más tarde.',
    "CONTACT_EXISTS": 'Este contacto ya se encuentra registrado',
    "IN_PROCESS": 'En proceso',
    "IN_REVIEW": 'En revisión',
    "DOCUMENT_NOT_FOUND": 'Documento no encontrado',
    "PENDING": "Pendiente",
    "COMPLETED": 'Completado',
    "REJECTED": 'Rechazado',
    "INVALID_ACCOUNT": "Cuenta inválida",
    "YOU_REQUEST_CANNOT_BE_PROCESSED_AT_THIS_TIME": 'Su solicitud no puede ser procesada en este momento',
    "INVALID_ACCOUNT_NUMBER": 'Número de cuenta inválido'
} // End of dictionary object

export const getWordOfDictionary = (word) => {
    if (dictionary[word]) {
        return dictionary[word];
    }
    return word;
}